import { createSelector } from '@ngrx/store';
import { getMessagesState } from '../messages.selectors';

export const reviewsState = createSelector(
  getMessagesState,
  (state) => state.reviewsState
);
export const reviewsData = createSelector(reviewsState, (state) => state.data);

export const reviewsIsLoading = createSelector(
  reviewsState,
  (state) => state.isLoading
);
export const reviewsSuccess = createSelector(
  reviewsState,
  (state) => state.success
);
export const reviewsError = createSelector(
  reviewsState,
  (state) => state.error
);

export const reviewsHasBeenFetched = createSelector(
  reviewsState,
  (state) => state.fetched
);
